import { useState, useEffect, use } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import {
  getCart,
  getUser,
  getCartTotal,
  clearCart,
  getAuthToken,
} from "../../utils/cart";
import {
  addToCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
} from "../../utils/cart";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
  apiTest_Url,
  Unichat_Url,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp, getFormattedDate } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";
import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { EncryptionHelper } from "../../Services/Encrypt";
import { TailSpin } from "react-loader-spinner";

export default function PaymentConfirmationPage() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    SODBody,
    setSODBody,
  } = context;
  const { txnid } = useParams();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const decryptedTxnId = txnid ? EncryptionHelper.decrypt(txnid) : "";

  const decryptParam = (key: string, defaultValue = "") => {
    const value = searchParams.get(key);
    if (!value) return defaultValue;

    try {
      return EncryptionHelper.decrypt(value);
    } catch {
      return defaultValue;
    }
  };

  const status = decryptParam("status");
  const error = decryptParam("error");
  const email = decryptParam("email");
  const phone = decryptParam("phone");
  const easepayid = decryptParam("easepayid");
  const firstname = decryptParam("firstname");
  const amount = decryptParam("amount", "0");
  const mode = decryptParam("mode");
  const billToLedgerID = decryptParam("billToLedgerID");

  const orderId = "123";

  console.log({
    txnid,
    status,
    error,
    email,
    phone,
    easepayid,
    firstname,
    amount,
    mode,
    billToLedgerID,
  });

  useEffect(() => {
    generateSOD();
    window.scrollTo(0, 0);
  }, []);

  const generateSOD = () => {
    if (status == "success") {
      let url3 = `${BaseUrl}/api/finance/generateSOD`;

      const SOD = localStorage.getItem("SOD-UniversalDairy");
      const SODBody: any = SOD ? JSON.parse(SOD) : null;

      const Token: any = getAuthToken();

      const userData: any = getUser();

      //  console.log("Pay Body", SODBody);
      if (SODBody != null) {
        const shipwayUrl = `${Unichat_Url}/shipway/add-order`;

        let shipwaybody = {
          order_id: "",
          carrier_id: "",
          warehouse_id: 88731,
          return_warehouse_id: 88731,
          //  ewaybill: "AD767435878734PR",

          products: SODBody?.ObjItems?.map((item: any) => ({
            product: item?.AutofillTxt || "",
            price: item?.MRP,
            product_code: item?.ItemID,
            product_quantity: item?.Qty,
            discount: "0",
            tax_rate: "0",
            tax_title: "",
          })),

          discount: "0",
          shipping: "0",
          order_total: SODBody?.TotalAmt || "0",
          gift_card_amt: "0",
          taxes: "0",
          payment_type: "P",
          email: userData?.SignInEmail,
          billing_address: "#321",
          billing_address2: userData.Address,
          billing_city: userData.City,
          billing_state: userData.State,
          billing_country: userData.Country,
          billing_firstname: userData.LedgerName,
          billing_lastname: "",
          billing_phone: userData?.SignInMobile,
          billing_zipcode: userData?.Pincode,
          // billing_latitude: "10",
          //  billing_longitude: "20",
          shipping_address: "#321",
          shipping_address2: SODBody?.ShipTo?.AddressLine1,
          shipping_city: SODBody?.ShipTo?.City,
          shipping_state: SODBody?.ShipTo?.State,
          shipping_country: SODBody?.ShipTo?.Country,
          shipping_firstname: SODBody?.ShipTo?.AliasName,
          shipping_lastname: "",
          shipping_phone: SODBody?.ShipTo?.UserMobile,
          shipping_zipcode: SODBody?.ShipTo?.Pincode,
          //   shipping_latitude: "30",
          //   shipping_longitude: "40",
          //   order_weight: "110",
          //   box_length: "20",
          //   box_breadth: "15",
          //   box_height: "10",
          order_date: getFormattedDate(),
        };

        const ShipwayToken = ``;

        callApi(
          url3,
          SODBody,
          Token?.loginKey,
          (response: any) => {
            if (response != null) {
              if (response?.hasErrors === false) {
                setSODBody(null);

          

                generateInvoice(
                  SODBody?.UserID,
                  firstname,
                  SODBody?.sellerid,
                  SODBody?.seller,
                  SODBody?.ObjItems,
                  response?.response?.vchNo,
                  Token?.loginKey,
                );

                //  alert(response?.response?.msg);
              } else {
                setLoading(false);
                localStorage.removeItem("SOD-UniversalDairy");
                setSODBody(null);

                alert(response?.errors);
              }
            } else {
              setLoading(false);
              localStorage.removeItem("SOD-UniversalDairy");
              setSODBody(null);
            }
          },
          (error: any) => {
            setLoading(false);
            localStorage.removeItem("SOD-UniversalDairy");
            alert(error.toString());
          },
        );
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const generateInvoice = (
    UserID: any,
    User: any,
    SellerID: any,
    Seller: any,
    objitems: any,
    VchNo: string,
    Token: string,
  ) => {
    let invoiceBody = {
      OrderAgainstID: UserID,
      TransactionID: decryptedTxnId,
      OrderAgainst: decryptedTxnId,
      TaxInclusion: 0,
      VchDate: new Date().toISOString(),
      SoName: "",
      Currency: "INR",
      VchType: 4,
      Remarks: "Payment received",
      NetAmt: amount,
      PayableAmt: amount,
      DiscountAmt: 0.0,
      TaxAmt: 0.0,
      TaxType: amount,
      TotalAmt: amount,
      RoundOffAmt: amount,
      TdsPercent: 0.0,
      TcsAmt: 0.0,
      TcsPer: 0.0,
      TdsAmt: 0.0,
      TtCessAmt: 0.0,
      TtExtraCessAmt: 0.0,
      TotalQty: 0,
      UserID: UserID,
      toEmailID: email,
      RefVchNo: VchNo,
      BillFrom: {
        LedgerID: SellerID,
        LedgerName: Seller,
      },
      BillTo: {
        LedgerID: UserID,
        LedgerName: User,
      },
      ObjParticulars: [
        {
          LedgerID: UserID,
          Amount: amount,
        },
      ],

      ObjItems: objitems,
    };

    let url3 = `${BaseUrl}/api/finance/generateInvoice`;

    console.log("Pay Body", invoiceBody);
    callApi(
      url3,
      invoiceBody,
      Token,
      (response: any) => {
        if (response != null) {
          if (response?.hasErrors === false) {
            setLoading(false);
            localStorage.removeItem("SOD-UniversalDairy");
            // alert(response?.response?.msg);
          } else {
            setLoading(false);
            localStorage.removeItem("SOD-UniversalDairy");
            alert(response?.errors);
          }
        }else{
          setLoading(false);
          localStorage.removeItem("SOD-UniversalDairy");
           alert(response?.errors);
        }
      },
      (error: any) => {
        setLoading(false);
        localStorage.removeItem("SOD-UniversalDairy");
      },
    );
  };

  // const expectedDeliveryDate = new Date();
  // expectedDeliveryDate.setDate(expectedDeliveryDate.getDate() + 5);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl shadow-xl p-12">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-5xl text-green-600"></i>
            </div>

            {status == "success" && (
              <>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  Order Confirmed!
                </h1>

                <p className="text-lg text-gray-600 mb-8">
                  Thank you for your purchase. Your order has been successfully
                  placed.
                </p>
              </>
            )}

            {status != "success" && (
              <>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  Order {status}!
                </h1>
              </>
            )}

            <div className="bg-gray-50 rounded-xl p-6 mb-8">
              <div className="flex items-center justify-between mb-4">
                <span className="text-gray-600">Order Number</span>
                <div className="flex items-center gap-2">
                  <span className="font-bold text-gray-900">
                    {decryptedTxnId}
                  </span>
                  <button
                    onClick={() =>
                      navigator.clipboard.writeText(decryptedTxnId)
                    }
                    className="text-amber-600 hover:text-amber-700"
                  >
                    <i className="ri-file-copy-line"></i>
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between mb-4">
                <span className="text-gray-600">Total Amount</span>
                <span className="font-bold text-gray-900">₹{amount}</span>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-gray-600">Payment Status</span>
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                  <i className="ri-check-line"></i>
                  {status}
                </span>
              </div>
            </div>

            {/* <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-8">
              <div className="flex items-center justify-center gap-3 mb-2">
                <i className="ri-calendar-line text-2xl text-amber-600"></i>
                <h3 className="text-lg font-semibold text-gray-900">
                  Expected Delivery
                </h3>
              </div>
              <p className="text-2xl font-bold text-amber-600">
                {expectedDeliveryDate.toLocaleDateString("en-IN", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>

            <p className="text-gray-600 mb-8">
              A confirmation email has been sent to your registered email
              address with order details and tracking information.
            </p> */}

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* <Link
                to="/my-orders"
                className="px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
              >
                Track Order
              </Link> */}
              <Link
                to="/products"
                className="px-8 py-4 bg-white border-2 border-gray-300 text-gray-900 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap"
              >
                Continue Shopping
              </Link>
            </div>

            {/* <div className="mt-12 pt-8 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                What happens next?
              </h3>
              <div className="space-y-4 text-left">
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Order Processing
                    </h4>
                    <p className="text-sm text-gray-600">
                      We are preparing your order for shipment
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Quality Check
                    </h4>
                    <p className="text-sm text-gray-600">
                      Each product is carefully inspected for quality
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Shipped</h4>
                    <p className="text-sm text-gray-600">
                      Your order will be dispatched within 24 hours
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-amber-600 font-bold">4</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Delivered</h4>
                    <p className="text-sm text-gray-600">
                      Fresh products delivered to your doorstep
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <Footer />

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </div>
  );
}
